import request from 'utils/request';

export default async function login(body: any): Promise<any> {
  try {
    const { data: user } = await request(`/lineDriveService/user/signin`, {
      method: 'POST',
      body,
      headers: {
        Authorization: 'Bearer'
      }
    });

    return user;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}
